'use client'
import React, { createContext, useMemo } from 'react'
import { initializeApp } from 'firebase/app'
import { Auth, getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth'

import settings from '@/settings/public'

interface FirebaseContextType {
  firebaseAuth: Auth
}

export const FirebaseContext = createContext<FirebaseContextType>({} as FirebaseContextType)

export const FirebaseProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const firebaseApp = useMemo(() => initializeApp(settings?.firebase?.config || {}), [])

  const firebaseAuth = useMemo(() => {
    const auth = getAuth(firebaseApp)
    // Use localStorage instead of IndexedDB (default) — prevents "Connection to Indexed Database
    // server lost" errors on iOS Safari when app goes to background or storage is restricted.
    setPersistence(auth, browserLocalPersistence).catch(() => undefined)
    return auth
  }, [firebaseApp])

  return (
    <FirebaseContext.Provider value={{ firebaseAuth }}>
      {children}
    </FirebaseContext.Provider>
  )
}
